import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import {
  JobStatusIds,
  PlanStatus,
  Temperature_tags,
} from '@app/modules/job-listing/constants/job-listing.enum';
import { OrderStatusIds, OrderTypeIds } from '@app/constants/order.enum';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  convertCurrentTimezoneToISO(time: string): string {
    const localTime = new Date(time).toLocaleString();

    return localTime.toLocaleString();
  }

  getJobStatusKey(value: number): string | undefined {
    return Object.keys(JobStatusIds).find(
      (key) => JobStatusIds[key as keyof typeof JobStatusIds] === value
    );
  }

  getOrderStatus(value: number): string | undefined {
    return Object.keys(OrderStatusIds).find(
      (key) => OrderStatusIds[key as keyof typeof OrderStatusIds] === value
    );
  }
  getPlanStatus(value: number): string | undefined {
    return Object.keys(PlanStatus).find(
      (key) => PlanStatus[key as keyof typeof PlanStatus] === value
    );
  }

  getOrderTypeIdsKey(value: number): string | undefined {
    return Object.keys(OrderTypeIds).find(
      (key) => OrderTypeIds[key as keyof typeof OrderTypeIds] === value
    );
  }

  getTemperatureType(value: number): string | undefined {
    return Object.keys(Temperature_tags).find(
      (key) => Temperature_tags[key as keyof typeof Temperature_tags] === value
    );
  }
}
